// test2524
(2524 && 0);
